import { Palette } from '@orgus/ui/icons';
import { AppearancePicker, DENSITY_OPTIONS, Segmented } from '@orgus/ui';
import type { ReactNode } from 'react';
import { usePrefs } from '../../../lib/prefs.ts';
import type { SettingsSection } from '../registry.ts';

function Field({ title, help, children }: { title: string; help: string; children: ReactNode }) {
  return (
    <div className="flex min-h-row-2line flex-wrap items-center justify-between gap-4 px-4 py-3">
      <div className="flex min-w-0 max-w-120 flex-col">
        <p className="text-ui font-medium text-fg">{title}</p>
        <p className="text-caption text-fg-subtle">{help}</p>
      </div>
      {children}
    </div>
  );
}

function Appearance() {
  const mode = usePrefs((s) => s.mode);
  const setMode = usePrefs((s) => s.setMode);
  const density = usePrefs((s) => s.density);
  const setDensity = usePrefs((s) => s.setDensity);
  return (
    <div className="flex flex-col gap-1 rounded-card border border-border bg-surface p-1 shadow-elevation-flat surface-sheen">
      <Field title="Theme" help="Light, dark, or follow this computer.">
        <AppearancePicker mode={mode} onMode={setMode} />
      </Field>
      <Field title="Density" help="Compact fits more rows on every list.">
        <Segmented label="Density" value={density} onChange={setDensity} options={DENSITY_OPTIONS.map((o) => ({ ...o }))} />
      </Field>
    </div>
  );
}

const section: SettingsSection = {
  id: 'appearance',
  title: 'Appearance',
  description: 'Theme and row density, for this browser.',
  order: 10,
  group: 'browser',
  keywords: ['theme', 'dark', 'light', 'system', 'density', 'compact'],
  icon: Palette,
  Component: Appearance,
};
export default section;
